import React, { useEffect } from 'react';

function NotificationsPage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const notificationText = "Warm reminder: Please contact customer service through the platform customer service button every time. Don't trust anyone outside the platform who claims to be customer service.";

  return (
    <div className="notifications-page">
      {/* Top Navigation Bar */}
      <div className="notifications-top-bar">
        <div className="notifications-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="notifications-title-text">
          <i className="bi bi-bell-fill me-2"></i>
          Notifications
        </div>
        <div className="notifications-spacer"></div>
      </div>

      {/* Main Content */}
      <div className="notifications-content">
        <div className="container-fluid px-3 py-3">
          <div className="notification-banner-enhanced">
            <div className="notification-banner-glow"></div>
            <div className="d-flex align-items-center">
              <div className="notification-icon-container-enhanced me-3">
                <div className="notification-icon-pulse"></div>
                <i className="bi bi-bell-fill"></i>
              </div>
              <div className="notification-text-enhanced">
                <div className="notification-warning-badge">⚠️ Important</div>
                <p>{notificationText}</p>
              </div>
            </div>
            <div className="notification-shine-effect"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationsPage;

